import { render, staticRenderFns } from "./KarsilastirmaliRaporlamaView.vue?vue&type=template&id=937ca01c"
import script from "./KarsilastirmaliRaporlamaView.vue?vue&type=script&lang=ts"
export * from "./KarsilastirmaliRaporlamaView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports